import React from 'react';
import { Box } from '@flexisaf/flexibull2';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
// eslint-disable-next-line react/prop-types
const LoaderWrapper = ({isLoading, count=0, children}) => {
    if (!isLoading) return <>{children}</>
    return (
        <Box width="100%" vAlign>
            <Box width="100%" margin="30px 0" align="center">
              <SkeletonTheme color="#d0d5d933" highlightColor="#c2cad133">
                <Skeleton count={count || 8} height={50} />
              </SkeletonTheme>
            </Box>
          </Box>
    )
}

export default LoaderWrapper;